export const getPageH1Title = (pathname) => {
  if (pathname === '/about') {
    return 'LEVRAI 소개';
  }
  if (pathname === '/product') {
    return 'LEVRAI 제품';
  }
  return 'LEVRAI';
};
